import { ClockIcon, GraphDownIcon, SellIcon } from '@cash-me/react-components'
export const tips = [
  {
    id: 'tips-1',
    icon: GraphDownIcon,
    title: 'Fique atento aos golpes',
    description:
      'Empresas fraudulentas podem se aproveitar da situação para cobrar depósitos antecipados, por exemplo. Pesquise antes de fechar qualquer negócio e não pague nenhum valor até receber o crédito em sua conta. Fique atento aos sites e às informações solicitadas.'
  },
  {
    id: 'tips-2',
    icon: ClockIcon,
    title: 'Preencha o formulário de simulação corretamente',
    description:
      'Esse processo de simulação da Portabilidade de Dívidas é muito importante. Por isso, é fundamental que as informações estejam corretas para facilitar a análise de crédito por parte de nossos consultores.'
  },
  {
    id: 'tips-3',
    icon: SellIcon,
    title: 'Negocie suas dívidas',
    description:
      'Com o valor do crédito em mãos, é mais fácil negociar suas dívidas, com a possibilidade de conseguir descontos para pagamento à vista e redução do valor de parcelamentos.'
  }
]
